<template>
  <d2-container>
    <template slot="header">
      <el-input
        clearable
        @keyup.enter.native="getSearch"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入大赛标题"
        size="small"
        v-model="listQuery.keyword"
      ></el-input>
      <el-select
        @keyup.enter.native="getSearch"
        v-model="listQuery.classifyId"
        clearable
        placeholder="请选择分类id"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option
          v-for="item in asStatusList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        ></el-option>
      </el-select>
      <el-button @click="getSearch" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-button
      class="filter-item"
      style="margin-left: 10px;"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      v-permission:function="['competitionDManager:btn_add']"
      @click="getAdd"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      :data="list"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
    >
      <el-table-column align="center" label="id" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.id}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="标题">
        <template slot-scope="scope">
          <span>{{scope.row.title}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="副标题">
        <template slot-scope="scope">
          <span>{{scope.row.subTitle}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="主题视频" width="280">
        <template slot-scope="scope">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="scope.row.arrList"
          ></video-player>
        </template>
      </el-table-column>-->
      <el-table-column align="center" label="创建时间" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.createTime}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.updateTime}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="开始时间" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.startTime}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="结束时间" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.endTime}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="开奖状态" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.isLottery == 0 ? '未开奖':'已开奖'}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" width="130">
        <template slot-scope="scope">
          <span
            :class="scope.row.status == 0 ? '' : (scope.row.status == 1 ? 'greed' : (scope.row.status == 2 ? 'red' : (scope.row.status == 3 ? 'blue':'')))"
          >{{ scope.row.status == 0 ? '未开始' : (scope.row.status == 1 ? '进行中' : (scope.row.status == 2 ? '已结束' : (scope.row.status == 3 ? "已关闭":""))) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="280" fixed="right">
        <template slot-scope="scope">
          <el-button size="small"
          v-permission:function="['competitionDManager:btn_edit']"
           type="success" @click="getEdit(scope.row)">编辑</el-button>
          <el-button
            size="small"
            type="primary"
            @click="putOnTheShelf(scope.row.id)"
            v-permission:function="['competitionDManager:btn_put']"
            :disabled="scope.row.state == 1 ?true:false"
          >开启</el-button>
          <el-button
            size="small"
            type="primary"
            @click="offTheShelf(scope.row.id)"
            v-permission:function="['competitionDManager:btn_off']"
            :disabled="scope.row.state == 0 ?true:false"
          >关闭</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </template>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  megagameList,
  megagameOpen,
  megagameClose,
  megagameClassifyOptions
} from '@/api/demo/competition/index'
import { videoPlayer } from 'vue-video-player'
export default {
  name: 'competitionDManager',
  data () {
    return {
      competitionDManager_btn_add: false,
      competitionDManager_btn_edit: false,
      competitionDManager_btn_put: false,
      competitionDManager_btn_off: false,

      tableKey: 0,
      list: [],
      total: null,
      listLoading: true, // 加载圈圈
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        keyword: '',
        classifyId: ''
      },
      asStatusList: []
    }
  },
  components: {
    videoPlayer
  },
  computed: {
    ...mapGetters(['elements'])
  },
  created () {
    let that = this
    that.getList()
    that.getClassList()
  },
  watch: {
    $route (to, from) {
      this.getList()
    }
  },
  methods: {
    // 添加大赛
    getAdd () {
      this.$router.push('./competition/addContest')
    },
    // 查询列表
    getList (val) {
      let that = this
      if (val) {
        that.listQuery.currentPage = val
      } else {
        that.listQuery.currentPage = 1
      }
      megagameList(that.listQuery).then(res => {
        that.listLoading = true
        for (let index = 0; index < res.records.length; index++) {
          let key11 = 'arrList'
          let value11 = {}
          res.records[index][key11] = value11
          res.records[index].arrList = {
            playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
            autoplay: false, // 如果为true,浏览器准备好时开始回放。
            muted: false, // 默认情况下将会消除任何音频。
            loop: false, // 是否视频一结束就重新开始。
            preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language: 'zh-CN',
            aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            sources: [
              {
                type: 'video/mp4', // 类型
                src: res.records[index].guideVideo // url地址
              }
            ],
            poster: '', // 封面地址
            notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
            controlBar: {
              timeDivider: true, // 当前时间和持续时间的分隔符
              durationDisplay: true, // 显示持续时间
              remainingTimeDisplay: false, // 是否显示剩余时间功能
              fullscreenToggle: true // 是否显示全屏按钮
            }
          }
        }
        that.list = res.records
        that.total = parseInt(res.total)
        that.listLoading = false
        console.log('that.list', that.list)
      })
    },
    getClassList () {
      let that = this
      megagameClassifyOptions().then(res => {
        console.log('megagameClassifyOptions', res)
        that.asStatusList = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getList(val)
    },
    // 开启成功
    putOnTheShelf (id) {
      let that = this
      megagameOpen(id).then(res => {
        that.getList(that.listQuery.currentPage)
        that.$notify({
          title: '成功',
          message: '开启成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    // 关闭活动
    offTheShelf (id) {
      let that = this
      megagameClose(id).then(res => {
        that.getList(that.listQuery.currentPage)
        that.$notify({
          title: '成功',
          message: '关闭成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    // 搜索
    getSearch () {
      let that = this
      that.getList(1)
    },
    // 编辑
    getEdit (row) {
      this.$router.push({
        path: './competition/addContest',
        query: {
          id: row.id
        }
      })
    }
  }
}
</script>
<style scoped>
.greed {
  color: green;
}
.red {
  color: red;
}
.blue {
  color: blue;
}
</style>
